<template>
  <h1>Ups, Not Found.</h1>
</template>

<script>
  export default {
    name: 'NotFound',
  };
</script>